export interface Testimonial {
  name: string
  flag: string
  country: string
  quote: string
  photo: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Maria L.',
    flag: '🇨🇴',
    country: 'Colombia',
    quote:
      'What I liked most was learning to stop thinking only about the mark. Now I have a sequence that helps me organize the analysis before reaching for the paper.',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/e2ccdb7d-c036-4edb-a674-e95e6e011cd1.jpg',
  },
  {
    name: 'Jorge R.',
    flag: '🇲🇽',
    country: 'Mexico',
    quote:
      'The decision map is probably the tool I use the most. It helps me organize the case when there are several variables at the same time.',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/a06c5cad-1371-43d5-ae44-6375d09bd968.jpg',
  },
  {
    name: 'Andrea P.',
    flag: '🇻🇪',
    country: 'Venezuela',
    quote:
      'I liked it because it isn’t another course packed with theory. The tools make it something I can actually reference when I need it.',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/439dab87-08d5-4139-b44f-02cec322a6b5.jpg',
  },
  {
    name: 'Carlos S.',
    flag: '🇪🇸',
    country: 'Spain',
    quote:
      'The Before the Paper checklist is incredibly practical. It made me rethink the order in which I was approaching my cases.',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/93d6dd7f-044d-4088-928b-12c5cfce3b38.jpg',
  },
  {
    name: 'Lucía M.',
    flag: '🇦🇷',
    country: 'Argentina',
    quote:
      'It didn’t feel like I bought another PDF. It felt like I acquired a framework for organizing my clinical reasoning.',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/dc426e11-98b3-41f0-8b24-17f3c1c59a04.jpg',
  },
]
